module.exports = __webpack_public_path__ + "img/Pkw_4x4_Transporter_teaser.4285216a.jpg";